import { gql } from '@apollo/client';

export default gql`
  mutation updateSquadMembers($input: UpdateSquadMembersInput!) {
    updateSquadMembers(input: $input) {
      id
    }
  }
`;
